"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard.js"));
var _default = exports.default = {
  'notice': function notice() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/notice'));
    });
  },
  'noticeContent': function noticeContent() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/noticeContent'));
    });
  },
  'configuration': function configuration() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/configuration'));
    });
  },
  'district': function district() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/district'));
    });
  },
  'account': function account() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/account'));
    });
  },
  'messagePush': function messagePush() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/messagePush'));
    });
  },
  'sfeLoginLog': function sfeLoginLog() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/sfeLoginLog'));
    });
  },
  'organizationArchitecture': function organizationArchitecture() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/organizationArchitecture'));
    });
  },
  'doubleWeekPlan': function doubleWeekPlan() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/doubleWeekPlan'));
    });
  },
  'storeVisitReport': function storeVisitReport() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/storeVisitReport'));
    });
  },
  'SRStoreList': function SRStoreList() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/SRStoreList'));
    });
  },
  'CPStoreList': function CPStoreList() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/CPStoreList'));
    });
  },
  'DAStoreList': function DAStoreList() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/DAStoreList'));
    });
  },
  'salesArea': function salesArea() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/salesArea'));
    });
  },
  'material': function material() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/material'));
    });
  },
  'materialDetails': function materialDetails() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/materialDetails'));
    });
  },
  'storeDetails': function storeDetails() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/storeDetails'));
    });
  },
  'contractKPIManagement': function contractKPIManagement() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/contractKPIManagement'));
    });
  },
  'salesKPIManagement': function salesKPIManagement() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/salesKPIManagement'));
    });
  },
  'monthKPI': function monthKPI() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/reportModule/kpiReport'));
    });
  },
  'quarterKPI': function quarterKPI() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/reportModule/kpiReport'));
    });
  },
  'ordersByMonth': function ordersByMonth() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/reportModule/orderDetail'));
    });
  },
  'storeDetailList': function storeDetailList() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/reportModule/orderDetail/storeDetailList'));
    });
  },
  'SRStoreOrderDetailList': function SRStoreOrderDetailList() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/reportModule/SRStoreOrderDetailList'));
    });
  },
  'carpac': function carpac() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/reportModule/carpac'));
    });
  },
  'appVersion': function appVersion() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/appVersion'));
    });
  },
  'taskScheduleLog': function taskScheduleLog() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/taskScheduleLog'));
    });
  },
  'sopNew': function sopNew() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/kpiSet/sopNew'));
    });
  },
  'pattenKpi': function pattenKpi() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/kpiSet/pattenKpi'));
    });
  },
  'sop18': function sop18() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/kpiSet/sop18'));
    });
  },
  'sopTotal': function sopTotal() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/kpiSet/sopTotal'));
    });
  },
  'targetSegmentSop': function targetSegmentSop() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/kpiSet/targetSegmentSop'));
    });
  },
  'productTag': function productTag() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/kpiSet/productTag'));
    });
  },
  'spNameList': function spNameList() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/kpiSet/spNameList'));
    });
  },
  'planAndTaskList': function planAndTaskList() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/planAndTaskReport/planAndTaskList'));
    });
  },
  'CPPlanAndTaskList': function CPPlanAndTaskList() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/planAndTaskReport/CPPlanAndTaskList'));
    });
  },
  'taskListByAddress': function taskListByAddress() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/planAndTaskReport/taskListByAddress'));
    });
  },
  'taskListBySr': function taskListBySr() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/planAndTaskReport/taskListBySr'));
    });
  },
  'taskListByASM': function taskListByASM() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/planAndTaskReport/taskListByASM'));
    });
  },
  'sopAmount': function sopAmount() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/kpiSet/sopAmount'));
    });
  },
  'aopIntegral': function aopIntegral() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/kpiSet/aopIntegral'));
    });
  },
  'aopAmount': function aopAmount() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/kpiSet/aopAmount'));
    });
  },
  'DARegionAop': function DARegionAop() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/kpiSet/DARegionAop'));
    });
  },
  'activeTotalKpi': function activeTotalKpi() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/kpiSet/activeTotalKpi'));
    });
  },
  'historyAdjust': function historyAdjust() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/kpiSet/historyAdjust'));
    });
  },
  'fdmPermission': function fdmPermission() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/kpiSet/fdmPermission'));
    });
  },
  'RSMAndSP': function RSMAndSP() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/kpiSet/RSMAndSP'));
    });
  },
  'gasnSign': function gasnSign() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/kpiSet/gasnSign'));
    });
  },
  'carpacAreaRefSrInfo': function carpacAreaRefSrInfo() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/kpiSet/carpacAreaRefSrInfo'));
    });
  },
  'performanceReport': function performanceReport() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/performanceReport'));
    });
  },
  'CPPerformanceReport': function CPPerformanceReport() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/CPPerformanceReport'));
    });
  },
  'orderRecommended': function orderRecommended() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/reportModule/orderRecommended'));
    });
  },
  'taskList': function taskList() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/taskList'));
    });
  },
  'likeCommentList': function likeCommentList() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/likeCommentList'));
    });
  },
  'cciKpi': function cciKpi() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/reportModule/CCIReport'));
    });
  },
  'SRIntegralReport': function SRIntegralReport() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/reportModule/SRIntegralReport'));
    });
  },
  'RSMSalesBonusReport': function RSMSalesBonusReport() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/reportModule/RSMSalesBonusReport'));
    });
  },
  'salesPerformanceCity': function salesPerformanceCity() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/reportModule/salesPerformanceCity'));
    });
  },
  'salesPerformance': function salesPerformance() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/reportModule/salesPerformance/index'));
    });
  },
  'salesPerformanceStore': function salesPerformanceStore() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/reportModule/salesPerformance/salesPerformanceStore'));
    });
  },
  'channelDevelopment': function channelDevelopment() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/reportModule/channelDevelopment'));
    });
  },
  'workEfficiency': function workEfficiency() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/reportModule/workEfficiency'));
    });
  },
  'chatbot': function chatbot() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/chatbot'));
    });
  },
  'salesReport': function salesReport() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/salesReport'));
    });
  },
  'oilAllowance': function oilAllowance() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/oilAllowance'));
    });
  },
  'mealAllowance': function mealAllowance() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/mealAllowance'));
    });
  },
  'bailianReport': function bailianReport() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/reportModule/bailianReport'));
    });
  },
  'storeOnlineOrderReport': function storeOnlineOrderReport() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/reportModule/storeOnlineOrderReport'));
    });
  },
  'fdpReport': function fdpReport() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/reportModule/fdpReport'));
    });
  },
  'storeOnlineTMReport': function storeOnlineTMReport() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/reportModule/storeOnlineTMReport'));
    });
  },
  'extendedWarrantyResults': function extendedWarrantyResults() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/reportModule/extendedWarrantyResults'));
    });
  },
  'taskAssignment': function taskAssignment() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/sfe/taskAssignment'));
    });
  }
};